'use strict';

Odigeo.defineWidget('hand_baggage_summary', Odigeo.Widget.extend({
    modelClass: require('./model'),
    viewClass: require('./view'),

    storeBoardingOptions: function(data) {
        this.model.storeBoardingOptions(data);
    },
}));
